// Akis-ozel etiket mutations. Tag CRUD + card-tag atama/kaldirma.

export const CREATE_FLOW_TAG = `
  mutation CreateFlowTag(
    $flowId: Int!,
    $name: String!,
    $color: String!,
    $companyId: Int!,
    $createdBy: Int
  ) {
    insert_report_flow_tags_one(object: {
      flow_id: $flowId,
      name: $name,
      color: $color,
      company_id: $companyId,
      created_by: $createdBy
    }) {
      id
      flow_id
      name
      color
    }
  }
`;

export const UPDATE_FLOW_TAG = `
  mutation UpdateFlowTag($id: Int!, $name: String!, $color: String!) {
    update_report_flow_tags_by_pk(
      pk_columns: { id: $id },
      _set: { name: $name, color: $color }
    ) {
      id
      name
      color
    }
  }
`;

export const DELETE_FLOW_TAG = `
  mutation DeleteFlowTag($id: Int!) {
    delete_report_flow_tags_by_pk(id: $id) {
      id
    }
  }
`;

// Bir karta etiket ata (bulk). Junction insert.
export const ASSIGN_TAGS_TO_ITEM = `
  mutation AssignTagsToItem($rows: [report_flow_item_tags_insert_input!]!) {
    insert_report_flow_item_tags(
      objects: $rows,
      on_conflict: {
        constraint: report_flow_item_tags_item_id_tag_id_key,
        update_columns: []
      }
    ) {
      affected_rows
    }
  }
`;

// Bir karttan tum etiketleri sil (replaceAll pattern icin).
export const REMOVE_TAGS_FROM_ITEM = `
  mutation RemoveTagsFromItem($itemId: Int!, $tagIds: [Int!]) {
    delete_report_flow_item_tags(
      where: { item_id: { _eq: $itemId }, tag_id: { _in: $tagIds } }
    ) {
      affected_rows
    }
  }
`;

export const REMOVE_ALL_TAGS_FROM_ITEM = `
  mutation RemoveAllTagsFromItem($itemId: Int!) {
    delete_report_flow_item_tags(where: { item_id: { _eq: $itemId } }) {
      affected_rows
    }
  }
`;
